import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {submit} from 'redux-form';

import {withStyles} from '@material-ui/core/styles/index';
import Button from '@material-ui/core/Button';
import ContentAddIcon from '@material-ui/icons/Add';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import {createEmpresa, deleteEmpresa, fetchEmpresas, updateEmpresa} from '../actions/empresa';
import EmpresaForm from './EmpresaForm';
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";

const styles = theme => ({
    action: {
        margin: '10px',
        position: 'fixed',
        bottom: 0,
        right: 0
    },

    actions: {
        whiteSpace: 'nowrap',
        textAlign: 'right'
    },

    list: {
        marginBottom: 60
    },

    formControl: {
        marginRight: 24,
        minWidth: 120,
        display: 'flex'
    },

    selectEmpty: {
        marginRight: 24,
        marginTop: theme.spacing.unit * 2
    },

});

class Empresa extends Component {

    constructor(props) {
        super(props);

        this.state = {
            empresaFilter: 'NAO_ATRIBUIDA',
            empresas: [],
            dialogTitle: null,
            dialogActions: null,
            dialogOpen: false,
            dialogContent: null
        };
    }

    componentDidMount() {
        this.props.fetchEmpresas();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.empresas !== null) {            
            if (prevState.empresaFilter !== this.state.empresaFilter || prevProps.empresas == null) {
                let empresasFilter = this.props.empresas.filter((ele) => {
                    if (this.state.empresaFilter === 'NAO_ATRIBUIDA' && ele.contrato === null) {
                        return true;
                    }
                    return this.state.empresaFilter === 'TODAS' ? true : this.state.empresaFilter === ele.contrato;
                });
                this.setState({empresas: empresasFilter});
            }
        }
    }

    handleStateEmpresaFilter = (event) => {
        this.setState({empresaFilter: event.target.value});
    };

    handleOpenEditDialog(empresa, actions) {
        this.setState({dialogTitle: 'Editar'});
        this.setState({dialogOpen: !this.state.dialogOpen});
        this.setState({dialogActions: actions});
        this.setState({dialogContent: <EmpresaForm form="editForm" initialValues={empresa}/>});
    }

    handleOpenConfirmDialog(empresa, actions) {
        this.setState({dialogTitle: 'Confirmação'});
        this.setState({dialogOpen: !this.state.dialogOpen});
        this.setState({dialogActions: actions});
        this.setState({
            dialogContent:
                <Fragment>
                    <p>Deseja realmente a empresa {empresa.nome}?</p>
                    <p>Esta operação excluirá todos os eventos dessa empresa!</p>
                </Fragment>
        });
        this.setState({empresa: empresa});
    }

    handleOpenCreateDialog(actions) {
        this.setState({dialogTitle: 'Cadastrar'});
        this.setState({dialogOpen: !this.state.dialogOpen});
        this.setState({dialogActions: actions});
        this.setState({dialogContent: <EmpresaForm form="newForm"/>});
    }

    handleCloseDialog() {
        this.setState({dialogOpen: !this.state.dialogOpen});
    }

    handleCreate() {
        this.props.submitNewForm();
        let form = this.props.newForm;

        if (!form.syncErrors) {
            this.props.createEmpresa(form.values);
            this.handleCloseDialog();
        }
    }

    handleDelete() {
        this.props.deleteEmpresa(this.state.empresa.cnpj);
        this.handleCloseDialog();
    }

    handleUpdate() {
        this.props.submitEditForm();
        let form = this.props.editForm;

        if (!form.syncErrors) {
            this.props.updateEmpresa(form.values);
            this.handleCloseDialog();
        }
    }

    formatCnpj(cnpj) {
        return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }

    render() {
        const DIALOG_ACTION_DELETE = [
            <Button key="confirm" onClick={() => this.handleDelete()}>Confirmar</Button>,
            <Button key="cancel" color="primary" onClick={() => this.handleCloseDialog()}>Cancelar</Button>
        ];

        const DIALOG_ACTION_EDIT = [
            <Button key="change" onClick={() => this.handleUpdate()}>Alterar</Button>,
            <Button key="cancel" color="primary" onClick={() => this.handleCloseDialog()}>Cancelar</Button>
        ];

        const DIALOG_ACTION_CREATE = [
            <Button key="create" onClick={() => this.handleCreate()}>Cadastrar</Button>,
            <Button key="cancel" color="primary" onClick={() => this.handleCloseDialog()}>Cancelar</Button>
        ];

        return (
            <Fragment>
                <Grid container spacing={8}>
                    <Grid item sm={12} md={2}>
                        <FormControl className={this.props.classes.formControl}>
                            <InputLabel htmlFor="empresa">Empresa</InputLabel>
                            <Select value={this.state.empresaFilter} onChange={this.handleStateEmpresaFilter}
                                    input={<Input name="empresa"/>} className={this.props.selectEmpty}>
                                <MenuItem value="SUPRASYS">SUPRASYS</MenuItem>
                                <MenuItem value="INFORMECE">INFORMECE</MenuItem>
                                <MenuItem value="NAO_ATRIBUIDA">NÃO ATRIBUÍDA</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Table className={this.props.classes.list}>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Nome</TableCell>
                            <TableCell>CNPJ</TableCell>
                            <TableCell>Empresa</TableCell>
                            <TableCell/>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.empresas.map(row => (
                                <TableRow key={row.id}>
                                    <TableCell>{row.id}</TableCell>
                                    <TableCell>{row.nome}</TableCell>
                                    <TableCell>{this.formatCnpj(row.cnpj)}</TableCell>
                                    <TableCell>{row.contrato}</TableCell>
                                    <TableCell className={this.props.classes.actions}>
                                        <IconButton onClick={() => this.handleOpenConfirmDialog(row, DIALOG_ACTION_DELETE)}>
                                            <DeleteIcon/>
                                        </IconButton>
                                        <IconButton onClick={() => this.handleOpenEditDialog(row, DIALOG_ACTION_EDIT)}>
                                            <EditIcon/>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )
                        )}
                    </TableBody>
                </Table>

                <Button variant="fab" color="primary" onClick={() => this.handleOpenCreateDialog(DIALOG_ACTION_CREATE)}
                        className={this.props.classes.action}>
                    <ContentAddIcon/>
                </Button>

                <Dialog disableBackdropClick disableEscapeKeyDown open={this.state.dialogOpen}
                        aria-labelledby="user-dialog-title">
                    <DialogTitle id="user-dialog-title">{this.state.dialogTitle}</DialogTitle>
                    <DialogContent>{this.state.dialogContent}</DialogContent>
                    <DialogActions>{this.state.dialogActions}</DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        empresas: state.empresas.data,
        newForm: state.form.newForm,
        editForm: state.form.editForm
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchEmpresas: () => dispatch(fetchEmpresas()),
        createEmpresa: (empresa) => dispatch(createEmpresa(empresa)),
        deleteEmpresa: (cnpj) => dispatch(deleteEmpresa(cnpj)),
        updateEmpresa: (empresa) => dispatch(updateEmpresa(empresa)),
        submitNewForm: () => dispatch(submit('newForm')),
        submitEditForm: () => dispatch(submit('editForm'))
    };
};

export default compose(
    withStyles(styles, {name: 'Empresa'}),
    connect(mapStateToProps, mapDispatchToProps)
)(Empresa);


// WEBPACK FOOTER //
// src/components/Empresa.js